import { EmailDraft } from '../../../context'
import { useEmailDraftTableProvider } from '../Email.hooks'

function EmailDraftTableProvider({
  DraftContext = EmailDraft,
  children,
  prefix,
}) {
  const value = useEmailDraftTableProvider(prefix)

  return <DraftContext value={value}>{children}</DraftContext>
}

export default EmailDraftTableProvider
